import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { getDashboardStats } from '../../services/adminApi';

const StatCard = ({ label, value, sub, icon, color }) => (
  <div className={`stat-card ${color || ''}`}>
    <span className="stat-icon">{icon}</span>
    <div className="stat-label">{label}</div>
    <div className="stat-value">{value ?? <span className="skeleton" style={{ width: 60, height: 32, display: 'inline-block' }} />}</div>
    {sub && <div className="stat-sub">{sub}</div>}
  </div>
);

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    getDashboardStats()
      .then(r => setStats(r.data.stats))
      .catch(() => setError('Failed to load statistics'));
  }, []);

  const byStatus = key =>
    stats?.inventory?.byStatus?.find(s => s._id === key)?.count ?? 0;

  return (
    <AdminLayout title="Dashboard">

      {error && (
        <div style={{ background: 'var(--red-dim)', border: '1px solid #7f1d1d', color: 'var(--red)', borderRadius: 'var(--radius)', padding: '12px 16px', marginBottom: 20 }}>
          ⚠ {error}
        </div>
      )}

      {/* Row 1 — top-level counts */}
      <div className="stat-grid">
        <StatCard
          label="Registered Users"
          value={stats?.users?.total?.toLocaleString()}
          sub={<>+{stats?.users?.recent ?? '—'} this month</>}
          icon="👤"
        />
        <StatCard
          label="Service Providers"
          value={stats?.providers?.total?.toLocaleString()}
          icon="🏥"
          color="green"
        />
        <StatCard
          label="QR Codes Issued"
          value={stats?.assets?.total?.toLocaleString()}
          sub={<><span className="up">↑</span> {stats?.assets?.registered ?? '—'} registered</>}
          icon="▣"
          color="yellow"
        />
        <StatCard
          label="Inventory Items"
          value={stats?.inventory?.total?.toLocaleString()}
          icon="📦"
          color="purple"
        />
      </div>

      {/* Row 2 — secondary breakdown */}
      <div className="stat-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))' }}>
        <StatCard label="Unregistered QR"   value={stats?.assets?.unregistered?.toLocaleString()} icon="○" />
        <StatCard label="New Registrations" value={stats?.assets?.recentRegistrations?.toLocaleString()} sub="last 30 days" icon="✦" color="green" />
        <StatCard label="In Stock"          value={byStatus('in_stock')?.toLocaleString()}     icon="✓" color="green" />
        <StatCard label="Shipped"           value={byStatus('shipped')?.toLocaleString()}      icon="➜" color="yellow" />
        <StatCard label="Invalidated"       value={byStatus('invalidated')?.toLocaleString()}  icon="✕" color="red" />
      </div>

      {/* Inventory breakdown table */}
      {stats && (
        <div className="admin-table-wrap" style={{ marginTop: 8 }}>
          <div className="admin-table-header">
            <h3>Inventory by Product Type</h3>
          </div>
          <table className="admin-table">
            <thead>
              <tr>
                <th>Type</th>
                <th>Total</th>
                <th>In Stock</th>
                <th>Shipped</th>
                <th>Registered</th>
                <th>Invalidated</th>
              </tr>
            </thead>
            <tbody>
              {stats.assets?.byType?.length ? stats.assets.byType.map(row => (
                <tr key={row._id}>
                  <td style={{ textTransform: 'capitalize', fontWeight: 600 }}>{row._id || '—'}</td>
                  <td>{row.count}</td>
                  <td>—</td>
                  <td>—</td>
                  <td>—</td>
                  <td>—</td>
                </tr>
              )) : (
                <tr>
                  <td colSpan={6}>
                    <div className="empty-state"><p>No asset data yet</p></div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </AdminLayout>
  );
}
